import Layout from '@/layout';

export default {
  weight: 6,
  path: '/stat',
  component: Layout,
  redirect: '/statList',
  name: 'stat',
  meta: { title: '数据统计', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'orderStat',
      name: 'orderStat',
      component: () => import('@/views/stat/orderStat'),
      meta: { title: '订单量与金额统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'payUserStat',
      name: 'payUserStat',
      component: () => import('@/views/stat/payUserStat'),
      meta: { title: '下单用户数与支付用户数统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'wishStat',
      name: 'wishStat',
      component: () => import('@/views/stat/wishStat'),
      meta: { title: '心愿单添加统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'sellStat',
      name: 'sellStat',
      component: () => import('@/views/stat/sellStat'),
      meta: { title: '商品销售量统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'feedStat',
      name: 'feedStat',
      component: () => import('@/views/stat/feedStat'),
      meta: { title: '售后问题统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'searchStat',
      name: 'searchStat',
      component: () => import('@/views/stat/searchStat'),
      meta: { title: '搜索结果统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'productViews',
      name: 'productViews',
      component: () => import('@/views/stat/productViews'),
      meta: { title: '商品浏览统计', icon: 'el-icon-s-data' },
    },
    {
      path: 'miniProgramAccessLogs',
      name: 'miniProgramAccessLogs',
      component: () => import('@/views/logs/miniProgramAccessLogs'),
      meta: { title: '小程序访问日志', icon: 'el-icon-mobile-phone' },
    },
    {
      path: 'productViewLogs',
      name: 'productViewLogs',
      component: () => import('@/views/stat/productViewLogs'),
      meta: { title: '商品浏览日志', icon: 'el-icon-view' },
    },
    {
      path: 'tryOnStat',
      name: 'tryOnStat',
      component: () => import('@/views/stat/tryOnStat'),
      meta: { title: '试戴统计', icon: 'el-icon-s-data' },
    },
  ],
};
